import { defaultLanguage, defaultLocations } from '../consts';

export const buildLocale = (lang: string, location: string): string => {
  if (!location) {
    return lang;
  }
  if (location.toLowerCase() === defaultLocations[lang]) {
    return lang;
  }
  return `${lang}-${location.toUpperCase()}`;
};

export const defaultLocale = buildLocale(defaultLanguage, defaultLocations[defaultLanguage]);

export const convertLocaleToUnderscore = (locale: string): string => {
  return locale.replace('-', '_');
};
